<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="historial"
        :search="search"
        :sort-desc="true"
        sort-by="timeStamp"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Historial App movil</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <v-card>
                <v-card-title>
                  <span class="headline">Detalles del cliente</span>
                </v-card-title>

                <v-card-text class="pb-0">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="nameClient"
                          label="NOMBRE"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="phoneClient"
                          label="TELEFONO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="brandVehicle"
                          label="MARCA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="subBrandVehicle"
                          label="MODELO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="plateVehicle"
                          label="PLACA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="color"
                          label="COLOR"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="ageVehicle"
                          label="AÑO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="commentsClient"
                          label="COMENTARIOS"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="origin"
                          label="ORIGEN"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="destination"
                          label="DESTINO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="price > 0">
                        <v-text-field
                          v-model="price"
                          label="PRECIO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="questionFailed"
                          label="FALLA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="poliza"
                          label="POLIZA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-card-title class="pa-0">
                          <span class="headline">Detalles del proveedor</span>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="nameProvider"
                          label="NOMBRE"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="phoneProvider"
                          label="TELEFONO"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="brandProvider"
                          label="MARCA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="plateProvider"
                          label="PLACA"
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="limpiar()">CERRAR</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.timestamp`]="{ item }">
          <span>{{ new Date(item.timestamp).toLocaleString() }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import { dbRefHistory, dbRefCliente, dbRefProveedor } from "../main";
export default {
  data() {
    return {
      dialog: false,
      overlay: false,
      historial: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        { text: "Fecha", value: "timestamp", sortable: false },
        { text: "Origen", value: "origin", sortable: false },
        { text: "Marca", value: "brandVehicle", sortable: false },
        { text: "Modelo", value: "subBrandVehicle", sortable: false },
        { text: "Placa", value: "plateVehicle", sortable: false },
        { text: "Año", value: "yearVehicle", sortable: false },
        { text: "Color", value: "color", sortable: false },
        { text: "Tipo Asistencia", value: "typeAssistance", sortable: false },
        { text: "Estado", value: "status", sortable: false },
      ],
      search: "",
      ageVehicle: "",
      nameClient: "",
      nameProvider: "",
      phoneClient: "",
      phoneProvider: "",
      brandVehicle: "",
      calificationClient: "",
      calificationDriver: "",
      color: "",
      commentsClient: "",
      destination: "",
      destinationLat: "",
      destinationLng: "",
      idClient: "",
      idDriver: "",
      idHistoryBooking: "",
      idPurchaseTransaction: "",
      km: "",
      origin: "",
      originLat: "",
      originLng: "",
      paymentMethod: "",
      plateVehicle: "",
      price: "",
      questionAccident: "",
      questionFailed: "",
      status: "",
      subBrandVehicle: "",
      time: "",
      timeEnd: "",
      timeStamp: "",
      timeStart: "",
      tipoServicio: "",
      brandProvider: "",
      plateProvider: "",
      menuFechas: "",
      fechaInicio: "",
      fechaFin: "",
      poliza: "",
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.prueba = "hola";
      me.overlay = true;
      dbRefHistory
        .once("value", function (dataSnapshot) {
          var objectData = Object.keys(dataSnapshot.val()).map((key) => {
            return dataSnapshot.val()[key];
          });
          me.historial = objectData;
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("Error");
        });
    },
    listarFechas() {},
    verDetalles(item) {
      this.dialog = true;
      let me = this;
      //CON EL ID DEL CLIENTE Y PROVEEDOR VER SUS DETALLES
      dbRefCliente
        .child(item.idClient)
        .once("value", function (dataSnapshot) {
          if (dataSnapshot.val()) {
            me.nameClient = dataSnapshot.val().name;
            me.phoneClient = dataSnapshot.val().phone;
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      dbRefProveedor
        .child(item.idDriver)
        .once("value", function (dataSnapshot) {
          if (dataSnapshot.val()) {
            me.nameProvider = dataSnapshot.val().name;
            me.phoneProvider = dataSnapshot.val().phone;
            me.brandProvider = dataSnapshot.val().vehicleBrand;
            me.plateProvider = dataSnapshot.val().vehiclePlate;
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      this.brandVehicle = item.brandVehicle;
      this.subBrandVehicle = item.subBrandVehicle;
      this.plateVehicle = item.plateVehicle;
      this.colorVehicle = item.colorVehicle;
      this.ageVehicle = item.yearVehicle;
      this.commentsClient = item.commentsClient;
      this.origin = item.origin;
      this.destination = item.destination;
      this.price = item.priceAssistance;
      this.questionFailed = item.questionFailed;
      this.questionAccident = item.questionAccident;
      this.poliza = item.policy;
      this.color = item.color;
    },
    limpiar() {
      this.dialog = false;
      this.nameClient = "";
      this.nameProvider = "";
      this.phoneClient = "";
      this.phoneProvider = "";
      this.brandVehicle = "";
      this.subBrandVehicle = "";
      this.plateVehicle = "";
      this.colorVehicle = "";
      this.ageVehicle = "";
      this.commentsClient = "";
      this.origin = "";
      this.destination = "";
      this.price = "";
      this.questionFailed = "";
      this.questionAccident = "";
      this.timeStart = "";
      this.timeEnd = "";
      this.brandProvider = "";
      this.plateProvider = "";
    },
  },
};
</script>